import baseHttpService from "core/http/singleton/base";

import { getAccountInfoRes, PermissionItemRes, RolesMenuRes } from "./resTypes";

import {
  deleteImageBirthdayUrl,
  getAccountInfoUrl,
  permissionItemUrl,
  postChangeAvatarUrl,
  postChangeImageBirthdayUrl,
  rolesMenuUrl,
} from "./urls";

import {
  DeleteImageBirthdayParams,
  PostChangeAvatarParams,
  PostChangeImageBirthdayParams,
} from "./paramsTypes";

import { dataURLToFile } from "helper/file";

export const getAccountInfoApi = async (): Promise<getAccountInfoRes> => {
  const res = await baseHttpService.get<getAccountInfoRes>(getAccountInfoUrl);
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const postChangeAvatarApi = async (
  params: PostChangeAvatarParams
): Promise<getAccountInfoRes> => {
  const { file } = params;
  const fileData = dataURLToFile(file.content, file.name);

  const formData = new FormData();

  formData.append("file", fileData);

  const res = await baseHttpService.post<getAccountInfoRes>(
    postChangeAvatarUrl,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const postChangeImageBirthdayApi = async (
  params: PostChangeImageBirthdayParams
): Promise<getAccountInfoRes> => {
  const { file } = params;
  const fileData = dataURLToFile(file.content, file.name);

  const formData = new FormData();

  formData.append("file", fileData);

  const res = await baseHttpService.post<getAccountInfoRes>(
    postChangeImageBirthdayUrl,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const deleteImageBirthdayApi = async (
  params: DeleteImageBirthdayParams
) => {
  const res = await baseHttpService.delete(deleteImageBirthdayUrl(params));
  return res.data;
};

export const getRoleMenuApi = async (): Promise<RolesMenuRes> => {
  const res = await baseHttpService.get<RolesMenuRes>(rolesMenuUrl);
  if (!res || !res.data) throw new Error("Opps");
  return res.data;
};

export const getPermissionItemApi = async (
  screenCode: string
): Promise<PermissionItemRes> => {
  const res = await baseHttpService.get<PermissionItemRes>(
    permissionItemUrl(screenCode)
  );
  if (!res || !res.data) throw new Error("Opps");
  return res.data;
};
